<template>
  <div :class="['nt-select3', { 'nt-select3--error': error }, getTheme]">
    <label :for="id">{{ label }}</label>
    <v-select 
      :id="id" 
      :name="id" 
      :multiple="multiselect" 
      :close-on-select="!multiselect" 
      :options="filtered" 
      label="Text" 
      :value="this.selected"
      :placeholder="placeholder"
      :filterable="false"
      @search="query => search = query"
      @input="onSelectItem">
      </v-select>
    <div class="nt-form-error" v-if="error">{{ error }}</div>
    <div class="nt-form-text-helper" v-if="helperText">{{ helperText }}</div>
  </div>
</template>

<script>
import _ from 'lodash'

export default {
  name: 'nt-select3',
  props: {
    id: {
      type: String,
      default: 'select'
    },
    label: {
      type: String,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    dataSource: {
      type: Array,
      default: []
    },
    valueSelected: {
      type: String,
      default: null
    },
    validators: {
      type: Array,
      default: []
    },
    rounded: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'default'
    },
    multiselect: {
      type: Boolean,
      default: false
    },
    multiselectedValues: {
      type: Array,
      default: null
    },
    helperText: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      data: [],
      default: {
        Text: this.$props.placeholder,
        Value: null
      },
      opened: false,
      selected: null,
      error: null,
      contentPosition: 'bottom',
      search: ''
    }
  },
  watch: {
    '$parent.errors': function (values) {
      this.error = _.values(_.find(values, this.id, _.first))[0]
    }
  },
  computed: {
    getTheme() {
      return `nt-select3--${this.theme}`
    },
    contentClass() {
      return `nt-select3__content--${this.contentPosition}`
    },
    value() {
      return this.selected ? this.selected : this.default
    },
    filtered() {
      return this.dataSource.filter(item => {
        return item.Text.toLowerCase().includes(this.search.toLowerCase())
      })
    }
  },
  created() {
    this.data = this.dataSource

    this.selected = this.getItemSelected()

    const selectedValue = this.getItemSelectedValue()

    if (this.$parent.$data.formData !== undefined) {
      const { formData, validators } = this.$parent.$data
      // Add to form initial values
      Object.assign(formData, {
        [this.id]: selectedValue
      })
      // Add validators to form
      Object.assign(validators, {
        [this.id]: this.validators
      })
    }
  },
  mounted() {
  },
  methods: {
    getItemSelected() {
      let selected

      if (!this.multiselect) {
        selected = this.dataSource.find(item => item.Value.toString() === this.valueSelected)
      }
      else if (this.multiselectedValues !== null) {
        selected = []
        for (let i = 0; i < this.multiselectedValues.length; i++) {
          selected.push(this.dataSource.find(item => item.Value.toString() === this.multiselectedValues[i]))
        }
      }

      return selected
    },
    getItemSelectedValue() {
      let selectedValue
      if (this.multiselect) {
        selectedValue = (this.selected && this.selected.length > 0) ? this.selected.map(i => { return i.Value }) : null
      }
      else {
        selectedValue = this.selected ? this.selected.Value : null
      }

      return selectedValue
    },
    onSelectItem(item) {
      this.selected = item
      this.changeForm()
    },
    changeForm() {
      const selectedValue = this.getItemSelectedValue()
      this.$parent.$emit('changeForm', {
        [this.id]: selectedValue
      })
    }
  }
}
</script>

<style lang="scss">
  .nt-select3 {
    $wrap: &;
    margin: 0;
    position: relative;
    list-style: none;
    padding-inline-start: 0;

    &__label {
      display: flex;
      align-items: center;
      justify-content: space-between;
      border: 1px solid rgb(184, 184, 184);
      color: #9ddda9;
    }

    .vs__dropdown-toggle {
      padding: 15px;
      border-radius: 2px;
      background: white;
    }

    .vs__selected {
      margin-top: 0;
    }

    .vs__search, .vs__search:focus, .vs--single .vs__selected {
      font-family: "Open Sans", sans-serif;
      font-size: 1.375em;
      letter-spacing: -1px;
      font-weight: normal;
      padding: 0;
      margin: 0;
    }

    input {
      &::placeholder { /* Chrome, Firefox, Opera, Safari 10.1+ */
        font-weight: 300;
        color: rgb(204, 204, 204);
        opacity: 1; /* Firefox */
      }

      &:-ms-input-placeholder { /* Internet Explorer 10-11 */
        font-weight: 300;
        color: rgb(204, 204, 204);
      }

      &::-ms-input-placeholder { /* Microsoft Edge */
        font-weight: 300;
        color: rgb(204, 204, 204);
      }
    }

    &--small {
      .vs__dropdown-toggle {
        padding: 8px;
      }

      .vs__search, .vs__search:focus, .vs--single .vs__selected {
        font-size: 1rem;
      }
    }

    &--error {
      .vs__dropdown-toggle {
        border: 1px solid #bd081a;
      }
    }
  }

  .loader {
    text-align: center;
    color: #bbbbbb;
  }
</style>

